/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureSourceAccountAttributesInput {
  /**
  * ID of the Azure tenant the subscription belongs to.
  */
  'tenantId': string;
  /**
  * ID of the Azure source subscription.
  */
  'subscriptionId': string;
  /**
  * Name of the Azure resource group to scope permissions to. When provided, discovery and permissions are limited to this specific resource group. When omitted, permissions are scoped to the subscription. 
  */
  'resourceGroupName'?: string;
  /**
  * Resource group name for Eon\'s temporary internal resources. 
  */
  'eonInternalResourceGroupName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalResourceGroupName",
      "baseName": "eonInternalResourceGroupName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSourceAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}

